// 远程搜索下拉工厂：车牌/司机/身份证/车管/司管 五处复用。
// 交互：输入关键字 → 调 searchApi → 候选经 setItemData 回填下拉 → 选中项的 id 写入 model[prop]。
// remoteMethod 加 300ms 防抖：避免逐字符发请求、以及慢响应覆盖新响应导致的乱序。
import debounce from 'lodash/debounce'

export function useRemoteSearchSelect({
  label,
  prop,
  searchApi,
  paramKey,
  buildLabel,
  extraParams = {},
  placeholder = '请输入关键字搜索',
  minChars = 0,
  getBlm,
}) {
  const remoteMethod = debounce(async (query) => {
    const keyword = (query || '').trim()
    // 字符数不足 minChars 不发请求(服务端性能，如车牌需满 4 位)
    if (!keyword || keyword.length < minChars) return
    const { code, data } = await searchApi({
      [paramKey]: keyword,
      ...extraParams,
    })
    if (code !== 1) return
    const list = (data || []).map((item) => ({
      ...item,
      __label: buildLabel(item),
    }))
    const blm = getBlm && getBlm()
    if (blm && blm.setItemData) {
      blm.setItemData({ elConfigKey: 'list', key: prop, data: list })
    }
  }, 300)

  const column = {
    el: 'select',
    itemConfig: { label, prop },
    elConfig: {
      filterable: true,
      remote: true,
      clearable: true,
      'reserve-keyword': true,
      placeholder,
      'remote-method': remoteMethod,
      options: { label: '__label', value: 'id', list: [] },
    },
  }

  return { column, remoteMethod }
}
